import { Box, Stack, Typography } from '@mui/material';
import { type Control } from 'react-hook-form';

import { RaLabel } from '@modules/_shared/components/form/RaLabel';
import {
  RaNumber,
  type RaNumberProps,
} from '@modules/_shared/components/form/RaNumber';
import { useLocale } from '@shared/hooks/locale';

type NumberInputProps = Omit<
  RaNumberProps,
  'control' | 'name' | 'errors' | 'label'
> & { label?: string; name?: string };

export type RaRangeProps = {
  control: Control<any>;
  name: string;
  label: string;
  required?: boolean;
  slotProps?: {
    minInput?: NumberInputProps;
    maxInput?: NumberInputProps;
  };
};

export const RaRange: React.FC<RaRangeProps> = ({
  control,
  name,
  label,
  slotProps,
  required = false,
}) => {
  const { t } = useLocale();

  return (
    <Stack direction="column">
      <RaLabel label={label} required={required} />
      <Stack direction="row" spacing={1}>
        <RaNumber
          control={control}
          name={`${name}.min`}
          required={required}
          placeholder={t('No min')}
          {...(slotProps?.minInput ?? {})}
        />
        <Box
          sx={{
            flexGrow: 0,
            flexShrink: 1,
            display: 'flex',
            alignItems: 'flex-end',
          }}
        >
          <Typography variant="body2" sx={{ color: 'grey.500', mb: 2 }}>
            —
          </Typography>
        </Box>
        <RaNumber
          control={control}
          name={`${name}.max`}
          required={required}
          placeholder={t('No max')}
          {...(slotProps?.maxInput ?? {})}
        />
      </Stack>
    </Stack>
  );
};
